module.exports = __webpack_public_path__ + "static/media/prop-9-thumb.34c688fc.webp";